//🔶 WebGL 쇼핑백 3D 미리보기

(() => {
  const MAX_WIDTH = 500;
  const MAX_DEPTH = 300;
  const MAX_HEIGHT = 500;
  const FIXED_MODEL_SCALE = 3.75 / MAX_HEIGHT;
  const OFFICE_GEAR_LOGO_DATA_URL = "data:image/jpeg;base64,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";

  let canvas = null;
  let gl = null;
  let program = null;
  let faceBuffer = null;
  let handleBuffer = null;
  let texture = null;
  let animationId = null;
  let lastFrameTime = 0;
  let isDragging = false;
  let lastPointerX = 0;
  let lastPointerY = 0;
  let autoRotate = true;
  let autoRotateTimer = null;

  const state = {
    width: 240,
    depth: 120,
    height: 350,
    rotationX: 0.18,
    rotationY: -0.55,
    vertexCount: 0,
    handleVertexCount: 0
  };

  // 리퀴드에서 호출하는 전역 함수
  window.updateValues = function updateValues() {
    canvas = document.getElementById("bagCanvas");
    if (!canvas) return;

    state.width = clampNumber(document.getElementById("bagWidth")?.value, 240, MAX_WIDTH);
    state.depth = clampNumber(document.getElementById("bagDepth")?.value, 120, MAX_DEPTH);
    state.height = clampNumber(document.getElementById("bagHeight")?.value, 350, MAX_HEIGHT);

    if (!initWebGL()) {
      drawFallback();
      return;
    }

    resizeCanvas();
    updateGeometry();
    render();
    startAnimation();
  };

  // 숫자 입력값 정리
  function clampNumber(value, fallback, max) {
    const number = parseFloat(value);
    if (!Number.isFinite(number) || number <= 0) return fallback;
    return Math.min(number, max);
  }

  // WebGL 초기화
  function initWebGL() {
    if (gl && program) return true;

    gl = canvas.getContext("webgl", { antialias: true, alpha: true });
    if (!gl) return false;

    const vertexShader = createShader(gl.VERTEX_SHADER, `
      attribute vec3 aPosition;
      attribute vec3 aColor;
      attribute vec2 aTexCoord;
      attribute float aTextureMix;
      attribute float aShade;

      uniform mat4 uMatrix;

      varying vec3 vColor;
      varying vec2 vTexCoord;
      varying float vTextureMix;
      varying float vShade;

      void main() {
        gl_Position = uMatrix * vec4(aPosition, 1.0);
        vColor = aColor;
        vTexCoord = aTexCoord;
        vTextureMix = aTextureMix;
        vShade = aShade;
      }
    `);

    const fragmentShader = createShader(gl.FRAGMENT_SHADER, `
      precision mediump float;

      uniform sampler2D uTexture;

      varying vec3 vColor;
      varying vec2 vTexCoord;
      varying float vTextureMix;
      varying float vShade;

      void main() {
        vec4 textureColor = texture2D(uTexture, vTexCoord);
        float logoAlpha = textureColor.a * vTextureMix;
        vec3 baseColor = mix(vColor, textureColor.rgb, logoAlpha);
        gl_FragColor = vec4(baseColor * vShade, 1.0);
      }
    `);

    program = createProgram(vertexShader, fragmentShader);
    faceBuffer = gl.createBuffer();
    handleBuffer = gl.createBuffer();
    texture = createLogoTexture();

    gl.useProgram(program);
    gl.enable(gl.DEPTH_TEST);
    gl.disable(gl.CULL_FACE);
    gl.clearColor(0.98, 0.98, 0.98, 1);

    setupPointerEvents();
    return true;
  }

  // 셰이더 생성
  function createShader(type, source) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      throw new Error(gl.getShaderInfoLog(shader) || "WebGL shader compile error");
    }

    return shader;
  }

  // 프로그램 생성
  function createProgram(vertexShader, fragmentShader) {
    const createdProgram = gl.createProgram();
    gl.attachShader(createdProgram, vertexShader);
    gl.attachShader(createdProgram, fragmentShader);
    gl.linkProgram(createdProgram);

    if (!gl.getProgramParameter(createdProgram, gl.LINK_STATUS)) {
      throw new Error(gl.getProgramInfoLog(createdProgram) || "WebGL program link error");
    }

    return createdProgram;
  }

  // 로고 텍스처 생성
  function createLogoTexture() {
    const textureCanvas = document.createElement("canvas");
    textureCanvas.width = 1024;
    textureCanvas.height = 1024;

    const ctx = textureCanvas.getContext("2d");
    ctx.clearRect(0, 0, textureCanvas.width, textureCanvas.height);

    const createdTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, createdTexture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureCanvas);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

    const logoImage = new Image();
    logoImage.onload = () => {
      const sourceCanvas = document.createElement("canvas");
      sourceCanvas.width = logoImage.width;
      sourceCanvas.height = logoImage.height;

      const sourceCtx = sourceCanvas.getContext("2d");
      sourceCtx.drawImage(logoImage, 0, 0);

      const imageData = sourceCtx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
      for (let i = 0; i < imageData.data.length; i += 4) {
        const r = imageData.data[i];
        const g = imageData.data[i + 1];
        const b = imageData.data[i + 2];
        const brightness = (r + g + b) / 3;

        if (brightness < 38) {
          imageData.data[i + 3] = 0;
        }
      }
      sourceCtx.putImageData(imageData, 0, 0);

      ctx.clearRect(0, 0, textureCanvas.width, textureCanvas.height);

      const logoWidth = textureCanvas.width * 0.68;
      const logoHeight = logoWidth * (logoImage.height / logoImage.width);
      const logoX = (textureCanvas.width - logoWidth) / 2;
      const logoY = textureCanvas.height * 0.26;
      ctx.drawImage(sourceCanvas, logoX, logoY, logoWidth, logoHeight);

      gl.bindTexture(gl.TEXTURE_2D, createdTexture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureCanvas);
      render();
    };
    logoImage.src = OFFICE_GEAR_LOGO_DATA_URL;

    return createdTexture;
  }

  // 캔버스 크기 조정
  function resizeCanvas() {
    const cssWidth = parseFloat(getComputedStyle(canvas).width);
    const cssHeight = parseFloat(getComputedStyle(canvas).height);
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    if (!Number.isFinite(cssWidth) || !Number.isFinite(cssHeight) || cssWidth <= 0 || cssHeight <= 0) {
      return false;
    }

    const displayWidth = Math.floor(cssWidth * dpr);
    const displayHeight = Math.floor(cssHeight * dpr);

    if (canvas.width !== displayWidth || canvas.height !== displayHeight) {
      canvas.width = displayWidth;
      canvas.height = displayHeight;
    }

    gl.viewport(0, 0, canvas.width, canvas.height);
    return true;
  }

  // 쇼핑백 면과 끈 좌표 갱신
  function updateGeometry() {
    const dimensions = getNormalizedDimensions();
    const faces = buildFaceVertices(dimensions);
    const handles = buildHandleVertices(dimensions);

    state.vertexCount = faces.length / 10;
    state.handleVertexCount = handles.length / 10;

    gl.bindBuffer(gl.ARRAY_BUFFER, faceBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(faces), gl.STATIC_DRAW);

    gl.bindBuffer(gl.ARRAY_BUFFER, handleBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(handles), gl.STATIC_DRAW);
  }

  // 실제 mm 비율을 WebGL 화면 크기로 정규화
  function getNormalizedDimensions() {
    const scale = FIXED_MODEL_SCALE;

    return {
      w: state.width * scale,
      d: state.depth * scale,
      h: state.height * scale
    };
  }

  // 면 버텍스 생성
  function buildFaceVertices({ w, d, h }) {
    const x = w / 2;
    const y = h / 2;
    const z = d / 2;

    const p = {
      ftl: [-x, y, z],
      ftr: [x, y, z],
      fbr: [x, -y, z],
      fbl: [-x, -y, z],
      btl: [-x, y, -z],
      btr: [x, y, -z],
      bbr: [x, -y, -z],
      bbl: [-x, -y, -z]
    };

    const vertices = [];

    // 앞면
    addFace(vertices, [p.ftl, p.fbl, p.fbr, p.ftr], [0.920, 0.910, 0.870], 1, 1.0);
    // 오른쪽 면
    addFace(vertices, [p.ftr, p.fbr, p.bbr, p.btr], [0.865, 0.855, 0.810], 0, 0.96);
    // 왼쪽 면
    addFace(vertices, [p.btl, p.bbl, p.fbl, p.ftl], [0.850, 0.840, 0.795], 0, 0.94);
    // 뒷면
    addFace(vertices, [p.btr, p.bbr, p.bbl, p.btl], [0.900, 0.892, 0.855], 1, 0.92);
    // 바닥면
    addFace(vertices, [p.fbl, p.bbl, p.bbr, p.fbr], [0.735, 0.725, 0.680], 0, 0.82);

    // 윗면은 비워 두고 안쪽 어두운 림만 추가해 쇼핑백 느낌을 줌
    const rimInset = Math.min(w, d) * 0.045;
    const rimY = y - 0.02;
    addFace(vertices, [
      [-x, y, z],
      [-x + rimInset, rimY, z - rimInset],
      [x - rimInset, rimY, z - rimInset],
      [x, y, z]
    ], [0.930, 0.920, 0.880], 0, 0.94);
    addFace(vertices, [
      [x, y, z],
      [x - rimInset, rimY, z - rimInset],
      [x - rimInset, rimY, -z + rimInset],
      [x, y, -z]
    ], [0.850, 0.840, 0.795], 0, 0.90);

    // 마치 접힘선
    addSideCrease(vertices, x, y, z, 1);
    addSideCrease(vertices, x, y, z, -1);

    return vertices;
  }

  // 마치 접힘 자국 추가
  function addSideCrease(vertices, x, y, z, side) {
    const creaseWidth = Math.max(z * 0.025, 0.008);
    const outerX = side * (x + 0.004);
    const topY = y * 0.96;
    const bottomY = -y * 0.96;
    const yJoin = -y * 0.40;

    addFace(vertices, [
      [outerX, topY, -creaseWidth],
      [outerX, yJoin, -creaseWidth],
      [outerX, yJoin, creaseWidth],
      [outerX, topY, creaseWidth]
    ], [0.825, 0.815, 0.765], 0, 0.90);

    // 마치가 접히는 거꾸로 Y자 형태의 보조선
    const lineColor = [0.785, 0.775, 0.725];
    const lineWidth = Math.max(z * 0.018, 0.006);
    addSideFoldLine(vertices, outerX + side * 0.002, topY, 0, yJoin, 0, lineWidth, lineColor, 0.92);
    addSideFoldLine(vertices, outerX + side * 0.002, yJoin, 0, bottomY, z * 0.96, lineWidth, lineColor, 0.88);
    addSideFoldLine(vertices, outerX + side * 0.002, yJoin, 0, bottomY, -z * 0.96, lineWidth, lineColor, 0.88);
  }

  // 마치 접힘선을 얇은 사각형으로 추가
  function addSideFoldLine(vertices, x, y1, z1, y2, z2, width, color, shade) {
    const dy = y2 - y1;
    const dz = z2 - z1;
    const length = Math.hypot(dy, dz) || 1;
    const offsetY = (-dz / length) * width * 0.5;
    const offsetZ = (dy / length) * width * 0.5;

    addFace(vertices, [
      [x, y1 + offsetY, z1 + offsetZ],
      [x, y2 + offsetY, z2 + offsetZ],
      [x, y2 - offsetY, z2 - offsetZ],
      [x, y1 - offsetY, z1 - offsetZ]
    ], color, 0, shade);
  }

  // 사각형 면 추가
  function addFace(vertices, points, color, textureMix, shade, texOverride) {
    const tex = texOverride || [
      [0, 0],
      [0, 1],
      [1, 1],
      [1, 0]
    ];

    const order = [0, 1, 2, 0, 2, 3];
    order.forEach((index) => {
      vertices.push(
        points[index][0],
        points[index][1],
        points[index][2],
        color[0],
        color[1],
        color[2],
        tex[index][0],
        tex[index][1],
        textureMix,
        shade
      );
    });
  }

  // 끈 버텍스 생성
  function buildHandleVertices({ w, d, h }) {
    const vertices = [];
    const handleColor = [0.025, 0.025, 0.025];
    const handleThickness = Math.max(w * 0.021, 0.023);
    const handleOffset = handleThickness * 0.55 + 0.006;

    // 앞/뒤 양쪽 손잡이를 모두 그림
    addHandleCurve(vertices, w, d / 2 + handleOffset, h, handleColor, 1.0);
    addHandleCurve(vertices, w, -d / 2 - handleOffset, h, handleColor, 0.82);

    return vertices;
  }

  // 곡선 끈 생성
  function addHandleCurve(vertices, w, z, h, color, shade) {
    const attachDrop = 30 * FIXED_MODEL_SCALE;
    const yAttach = h / 2 - attachDrop;
    const yPeak = h / 2 + h * 0.44;
    const xLeft = -w * 0.145;
    const xRight = w * 0.145;
    const xMid = 0;

    const curvePoints = [];
    for (let i = 0; i <= 32; i += 1) {
      const t = i / 32;
      const inv = 1 - t;
      const x = inv * inv * xLeft + 2 * inv * t * xMid + t * t * xRight;
      const y = inv * inv * yAttach + 2 * inv * t * yPeak + t * t * yAttach;
      curvePoints.push({ x, y, z });
    }

    const thickness = Math.max(w * 0.021, 0.023);
    for (let i = 0; i < curvePoints.length - 1; i += 1) {
      addRibbonSegment(vertices, curvePoints[i], curvePoints[i + 1], thickness, color, shade);
    }
  }

  // 각도에 따라 얇아지지 않는 튜브형 손잡이 생성
  function addRibbonSegment(vertices, pointA, pointB, thickness, color, shade) {
    const dx = pointB.x - pointA.x;
    const dy = pointB.y - pointA.y;
    const length = Math.hypot(dx, dy) || 1;
    const normalX = -dy / length;
    const normalY = dx / length;
    const radius = thickness * 0.5;
    const sides = 8;
    const ringA = [];
    const ringB = [];

    for (let i = 0; i < sides; i += 1) {
      const angle = (Math.PI * 2 * i) / sides;
      const normalOffset = Math.cos(angle) * radius;
      const zOffset = Math.sin(angle) * radius;

      ringA.push([
        pointA.x + normalX * normalOffset,
        pointA.y + normalY * normalOffset,
        pointA.z + zOffset
      ]);
      ringB.push([
        pointB.x + normalX * normalOffset,
        pointB.y + normalY * normalOffset,
        pointB.z + zOffset
      ]);
    }

    for (let i = 0; i < sides; i += 1) {
      const next = (i + 1) % sides;
      const sideShade = shade * (0.82 + 0.18 * Math.max(Math.sin((Math.PI * 2 * i) / sides), 0));
      pushQuad(vertices, ringA[i], ringA[next], ringB[next], ringB[i], color, sideShade);
    }
  }

  // 네 점으로 사각형 면 추가
  function pushQuad(vertices, p1, p2, p3, p4, color, shade) {
    pushVertex(vertices, p1, color, shade);
    pushVertex(vertices, p2, color, shade);
    pushVertex(vertices, p3, color, shade);
    pushVertex(vertices, p1, color, shade);
    pushVertex(vertices, p3, color, shade);
    pushVertex(vertices, p4, color, shade);
  }

  // 단일 버텍스 추가
  function pushVertex(vertices, point, color, shade) {
    vertices.push(point[0], point[1], point[2], color[0], color[1], color[2], 0, 0, 0, shade);
  }

  // 렌더링
  function render() {
    if (!gl || !program || !resizeCanvas()) return;

    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    gl.useProgram(program);

    const matrix = getSceneMatrix();
    gl.uniformMatrix4fv(gl.getUniformLocation(program, "uMatrix"), false, matrix);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.uniform1i(gl.getUniformLocation(program, "uTexture"), 0);

    bindAttributes(faceBuffer);
    gl.drawArrays(gl.TRIANGLES, 0, state.vertexCount);

    bindAttributes(handleBuffer);
    gl.drawArrays(gl.TRIANGLES, 0, state.handleVertexCount);
  }

  // 버퍼 속성 연결
  function bindAttributes(buffer) {
    const stride = 10 * Float32Array.BYTES_PER_ELEMENT;

    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    enableAttribute("aPosition", 3, stride, 0);
    enableAttribute("aColor", 3, stride, 3 * Float32Array.BYTES_PER_ELEMENT);
    enableAttribute("aTexCoord", 2, stride, 6 * Float32Array.BYTES_PER_ELEMENT);
    enableAttribute("aTextureMix", 1, stride, 8 * Float32Array.BYTES_PER_ELEMENT);
    enableAttribute("aShade", 1, stride, 9 * Float32Array.BYTES_PER_ELEMENT);
  }

  // 속성 활성화
  function enableAttribute(name, size, stride, offset) {
    const location = gl.getAttribLocation(program, name);
    if (location < 0) return;

    gl.enableVertexAttribArray(location);
    gl.vertexAttribPointer(location, size, gl.FLOAT, false, stride, offset);
  }

  // 장면 행렬 계산
  function getSceneMatrix() {
    const aspect = canvas.width / canvas.height || 1;
    const projection = mat4Perspective(Math.PI / 3, aspect, 0.1, 100);
    let model = mat4Identity();

    model = mat4Translate(model, 0, -0.12, -5.7);
    model = mat4RotateX(model, state.rotationX);
    model = mat4RotateY(model, state.rotationY);

    return mat4Multiply(projection, model);
  }

  // 애니메이션 시작
  function startAnimation() {
    if (animationId) return;

    const animate = (time) => {
      animationId = window.requestAnimationFrame(animate);

      // 약 30fps로 제한
      if (time - lastFrameTime < 33) return;
      lastFrameTime = time;

      if (autoRotate && !isDragging) {
        state.rotationY += 0.009;
      }

      render();
    };

    animationId = window.requestAnimationFrame(animate);
  }

  // 드래그 회전 이벤트
  function setupPointerEvents() {
    canvas.style.cursor = "grab";
    canvas.style.touchAction = "pan-y";

    canvas.addEventListener("pointerdown", (event) => {
      isDragging = true;
      autoRotate = false;
      lastPointerX = event.clientX;
      lastPointerY = event.clientY;
      canvas.style.cursor = "grabbing";
      canvas.setPointerCapture?.(event.pointerId);
    });

    canvas.addEventListener("pointermove", (event) => {
      if (!isDragging) return;

      const diffX = event.clientX - lastPointerX;
      const diffY = event.clientY - lastPointerY;
      lastPointerX = event.clientX;
      lastPointerY = event.clientY;

      state.rotationY += diffX * 0.012;
      state.rotationX += diffY * 0.006;
      state.rotationX = Math.max(-0.35, Math.min(0.65, state.rotationX));
      render();
    });

    const endDrag = (event) => {
      if (!isDragging) return;

      isDragging = false;
      canvas.style.cursor = "grab";
      canvas.releasePointerCapture?.(event.pointerId);

      window.clearTimeout(autoRotateTimer);
      autoRotateTimer = window.setTimeout(() => {
        autoRotate = true;
      }, 2500);
    };

    canvas.addEventListener("pointerup", endDrag);
    canvas.addEventListener("pointercancel", endDrag);
    canvas.addEventListener("pointerleave", endDrag);
  }

  // WebGL 미지원 fallback
  function drawFallback() {
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const cssWidth = parseFloat(getComputedStyle(canvas).width) || 640;
    const cssHeight = parseFloat(getComputedStyle(canvas).height) || 420;
    canvas.width = cssWidth;
    canvas.height = cssHeight;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#e8e3d3";
    ctx.fillRect(canvas.width * 0.28, canvas.height * 0.22, canvas.width * 0.38, canvas.height * 0.56);
    ctx.fillStyle = "#4f4b3f";
    ctx.font = "16px Arial, sans-serif";
    ctx.textAlign = "center";
    ctx.fillText("WebGLを利用できません。", canvas.width / 2, canvas.height / 2);
  }

  // 행렬 유틸리티
  function mat4Identity() {
    return new Float32Array([
      1, 0, 0, 0,
      0, 1, 0, 0,
      0, 0, 1, 0,
      0, 0, 0, 1
    ]);
  }

  function mat4Perspective(fov, aspect, near, far) {
    const f = 1 / Math.tan(fov / 2);
    const rangeInv = 1 / (near - far);

    return new Float32Array([
      f / aspect, 0, 0, 0,
      0, f, 0, 0,
      0, 0, (near + far) * rangeInv, -1,
      0, 0, near * far * rangeInv * 2, 0
    ]);
  }

  function mat4Translate(matrix, x, y, z) {
    return mat4Multiply(matrix, new Float32Array([
      1, 0, 0, 0,
      0, 1, 0, 0,
      0, 0, 1, 0,
      x, y, z, 1
    ]));
  }

  function mat4RotateX(matrix, angle) {
    const c = Math.cos(angle);
    const s = Math.sin(angle);

    return mat4Multiply(matrix, new Float32Array([
      1, 0, 0, 0,
      0, c, s, 0,
      0, -s, c, 0,
      0, 0, 0, 1
    ]));
  }

  function mat4RotateY(matrix, angle) {
    const c = Math.cos(angle);
    const s = Math.sin(angle);

    return mat4Multiply(matrix, new Float32Array([
      c, 0, -s, 0,
      0, 1, 0, 0,
      s, 0, c, 0,
      0, 0, 0, 1
    ]));
  }

  function mat4Multiply(a, b) {
    const out = new Float32Array(16);

    for (let row = 0; row < 4; row += 1) {
      for (let col = 0; col < 4; col += 1) {
        out[col * 4 + row] =
          a[0 * 4 + row] * b[col * 4 + 0] +
          a[1 * 4 + row] * b[col * 4 + 1] +
          a[2 * 4 + row] * b[col * 4 + 2] +
          a[3 * 4 + row] * b[col * 4 + 3];
      }
    }

    return out;
  }
})();
